import {
    type IFeedbackDto,
    type IUpdateFeedback,
    type IDoctorCard,
    type IAdditionalInfoNewDto
} from '@App/types/doctorsType'
import { API_URL } from '@Config/config'

import instance from '../instance'

export class DoctorsController {
    onGetDoctorCard(doctorId: string) {
        return instance.get(`${API_URL}/admin/employees/${doctorId}`)
    }

    onUpdateDoctorCard(doctorId: string, dto: IDoctorCard) {
        return instance.put(`${API_URL}/admin/employees/${doctorId}`, dto)
    }

    onGetUnpublishedFeedbacks(queries: string) {
        return instance.get(`${API_URL}/feedbacks/admin/unpublished${queries}`)
    }

    onGetDoctorsList(filters: string) {
        return instance.get(`${API_URL}/admin/employees${filters}`)
    }

    onGetFeedbacksById(queries: string) {
        return instance.get(`${API_URL}/feedbacks${queries}`)
    }

    onAddFeedback(dto: IFeedbackDto) {
        return instance.post(`${API_URL}/feedbacks`, dto)
    }

    onUpdateFeedback(dto: IUpdateFeedback) {
        return instance.put(`${API_URL}/feedbacks`, dto)
    }

    onRemoveFeedback(queries: string) {
        return instance.delete(`${API_URL}/feedbacks${queries}`)
    }

    onUploadImage(dto: FormData, queries: string) {
        return instance.post(`${API_URL}/storage/upload${queries}`, dto)
    }

    onChangeImage(dto: FormData, fileName: string, queries: string) {
        return instance.put(`${API_URL}/storage/${fileName}${queries}`, dto)
    }

    onRemoveImage(imageName: string, queries: string) {
        return instance.delete(`${API_URL}/storage/${imageName}${queries}`)
    }

    onGetAdditionalInfoByEmployeeId(queries: string) {
        return instance.get(`${API_URL}/employees/additinal-info${queries}`)
    }

    onUpdateAdditionalInfo(dto: IAdditionalInfoNewDto) {
        // TODO: Переделать по нормальному
        const _dto = {
            ...dto,
            additionalInfo: dto.additionalInfo.map((section) => ({
                ...section,
                items: section.items.map((item) => item.title)
            }))
        }
        return instance.put(`${API_URL}/employees/additinal-info`, _dto)
    }

    // onUpdateAdditionalInfoSection(doctorId: string, dto: IAdditionalInfoNew) {
    //     return instance.put(`${API_URL}/admin/doctors/${doctorId}/additional-info/${dto.additionalInfoId}`, dto)
    // }
}
